// Accordion JS End
let faqPreloadPromise;
const CONFIG = {
  CHAT_API_URL: "https://gregarious-friendship-production-eed4.up.railway.app/api/chat",
  FEEDBACK_API_URL: "https://gregarious-friendship-production-eed4.up.railway.app/api/feedback",
  SEARCH_DELAY: 500,
  MIN_SEARCH_LENGTH: 2,
};
let searchTimeout;
let faqChatConversationId = null;
let faqChatMessageId = null;

// ---------- PII validation (client-side pre-submit) ----------
const MONTH_PATTERN =
  'january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sep|sept|oct|nov|dec';

const PII_LABELS = {
  email: 'email address',
  creditCard: 'credit card number',
  auMobile: 'mobile number',
  auLandline: 'phone number',
  tfn: 'TFN',
  medicare: 'Medicare number',
  dob: 'date of birth',
  passport: 'passport number',
  number: 'number',
};

function passesLuhn(digits) {
  let sum = 0;
  let alt = false;
  for (let i = digits.length - 1; i >= 0; i--) {
    let n = +digits[i];
    if (alt) {
      n *= 2;
      if (n > 9) n -= 9;
    }
    sum += n;
    alt = !alt;
  }
  return sum % 10 === 0;
}
function isValidCreditCard(match) {
  const digits = match.replace(/\D/g, '');
  if (digits.length < 13 || digits.length > 19) return false;
  // The Luhn checksum is the actual differentiator: every genuine card number
  // passes it, while arbitrary 16-digit order/reference numbers almost always
  // fail. No format-based shortcuts here, otherwise Luhn would be bypassed.
  return passesLuhn(digits);
}
const CREDIT_CARD_RE =
  /\b(?:\d{4}[-\s]?){3}\d{1,4}\b|\b(?:3[47]\d{2}[-\s]?\d{6}[-\s]?\d{5}|(?:\d{4}[-\s]?){2}\d{4,7})\b/g;
function testCreditCard(text) {
  CREDIT_CARD_RE.lastIndex = 0;
  let m;
  while ((m = CREDIT_CARD_RE.exec(text))) {
    if (isValidCreditCard(m[0])) return true;
  }
  return false;
}
/** TFN compact — 9 digits only (no lookbehind for older browsers). */
function testTfnCompact(text) {
  return /(?:^|[^\d])(\d{9})(?:[^\d]|$)/.test(text);
}
/**
 * Count all digits in the string (letters/symbols ignored). 4+ digits total → blocked.
 * e.g. "gg12 n43" → 4 digits blocked, "gg12" → 2 digits OK
 */
function testLongNumber(text) {
  return (text.match(/\d/g) || []).length >= 4;
}

const PII_PATTERNS = [
  { key: 'email',    re: /\b[\w.+-]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])+)+\b/gi },
  { key: 'passport', re: /\b[A-Z]{1,2}\d{7}\b/i },

  // Specific number types — must come BEFORE the generic "number" fallback
  { key: 'auMobile', re: /\b0[45]\d{2}(?:\s\d+)+\b/g },
  { key: 'auMobile', re: /\b0[45]\d{6,}\b/g },
  { key: 'auMobile', re: /\+61\s?4\d{2}(?:\s\d+)+\b/g },
  { key: 'auMobile', re: /\+61\s?4\d{6,}\b/g },
  { key: 'auMobile', re: /\b61\s?4\d{2}(?:\s\d+)+\b/g },
  { key: 'auMobile', re: /\b614\d{6,}\b/g },

  { key: 'auLandline', re: /\(\s*0[12378]\s*\)(?:\s+\d{3,4})+\b/g },
  { key: 'auLandline', re: /\b0[12378](?:\s\d{3,4}){1,2}\b/g },
  { key: 'auLandline', re: /\b0[12378]\d{8}\b/g },
  { key: 'auLandline', re: /\b13(?:\s\d{2}){2}\b/g },
  { key: 'auLandline', re: /\b13\d{4}\b/g },
  { key: 'auLandline', re: /\b1[38]00(?:\s\d{3,4}){1,2}\b/g },
  { key: 'auLandline', re: /\b1[38]00\d{6,}\b/g },
  { key: 'auLandline', re: /\b[2-9]\d{7}\b/g },

  { key: 'creditCard', test: testCreditCard },

  { key: 'medicare', re: /\b\d{4}\s\d{5}\s?\d(?:\s?\d)?\b/g },
  { key: 'medicare', re: /\b[2-6]\d{9,10}\b/g },
  { key: 'medicare', re: /\b1\d{9,10}\b/g },

  { key: 'tfn', re: /\b\d{3}\s\d{3}\s\d{3}\b/g },
  { key: 'tfn', re: /\b\d{2}\s\d{3}\s\d{3}\b/g },
  { key: 'tfn', re: /\b\d{4}\s\d{3}\s\d{3}\b/g },
  { key: 'tfn', test: testTfnCompact },

  { key: 'dob', re: /\b\d{1,2}[\/\-\.]\d{1,2}[\/\-\.]\d{2,4}\b/gi },
  { key: 'dob', re: /\b\d{4}[\/\-\.]\d{1,2}[\/\-\.]\d{1,2}\b/gi },
  { key: 'dob', re: new RegExp('\\b\\d{1,2}\\s+(?:' + MONTH_PATTERN + ')\\s+\\d{2,4}\\b', 'gi') },
  { key: 'dob', re: new RegExp('\\b(?:' + MONTH_PATTERN + ')\\s+\\d{1,2},?\\s+\\d{2,4}\\b', 'gi') },
  { key: 'dob', re: new RegExp('\\b\\d{1,2}(?:st|nd|rd|th)?\\s+(?:' + MONTH_PATTERN + ')\\s+\\d{2,4}\\b', 'gi') },

  // Generic catch-all — MUST be last
  { key: 'number', test: testLongNumber },
];

function detectPII(text) {
  if (typeof text !== 'string' || !text.length) return null;
  for (const p of PII_PATTERNS) {
    let hit = false;
    if (p.test) {
      hit = p.test(text);
    } else {
      p.re.lastIndex = 0;
      hit = p.re.test(text);
    }
    if (hit) return p.key;
  }
  return null;
}
// -------------------------------------------------------------

// Faqs tabbing + slider
jQuery(function ($) {
  const $tabs = $(".faq_category_box");
  const $faqBlocks = $(".faq_articles_block");
  const $searchForm = $("#faqSearchForm");
  const $searchInput = $("#faqSearchBar");
  const $searchWrap = $searchInput.closest(".form_box");
  const $searchClearBtn = $(".faq_input_clear");
  const $hotSearchChips = $(".faq_hot_search_chip");
  const $searchResults = $(".faq_search_results");
  const $searchBlock = $("#faqSearchResults");
  const $faqHeading = $("#faqHeading");
  const $faqSlider = $(".faq_category_slider");
  const collapseAllFaqs = () => $(".faq_content").hide();
  let isInitialLoad = true;
  function updateInputUiState() {
    $searchWrap.toggleClass("has-value", Boolean($searchInput.val().trim()));
  }
  function showTabByHandle(handle) {
    $tabs.removeClass("active").filter(`[data-blog='${handle}']`).addClass("active");
    $faqBlocks.each(function () {
      const $block = $(this);
      const match = $block.data("blog") === handle;
      $block.toggleClass("is-hidden-tab", !match).closest(".faq_tab_content_box").toggleClass("is-hidden-tab", !match);
      if (match) {
        collapseAllFaqs();
        const $firstItem = $block.find(".accordion_items").first();
        $firstItem.addClass("active_faq");
        $firstItem.find(".faq_content").show();
        $block.hide().outerHeight();
        $block.show();
        if (handle !== $tabs.first().data("blog")) {
          scrollToElement(jQuery(".faq-categories_wp")[0]);
        } else if (handle == $tabs.first().data("blog") && isInitialLoad == false) {
          scrollToElement(jQuery(".faq-categories_wp")[0]);
        }
      }
    });
    if (isInitialLoad == true) {
      isInitialLoad = false;
    }
    $searchBlock.hide();
    $searchResults.empty();
    $searchInput.val("");
    updateInputUiState();
    $faqHeading.show();
  }
  const faqPageCache = {};
  faqPreloadPromise = Promise.all(
    $tabs
      .map(function () {
        const handle = $(this).data("blog");
        if (faqPageCache[handle]) return Promise.resolve();
        const allItems = [];
        let page = 1;
        const fetchPages = async () => {
          while (true) {
            try {
              const res = await fetch(`/blogs/${handle}?page=${page}`);
              const html = await res.text();
              const $temp = $("<div>").html(html);
              const items = $temp.find(".accordion_items");
              if (!items.length) break;
              allItems.push(...items);
              page++;
            } catch {
              break;
            }
          }
          faqPageCache[handle] = allItems;
        };
        return fetchPages();
      })
      .get()
  );
  let searchLock = false;
  async function submitAiFeedback(rating, $chat) {
    if (!faqChatConversationId || !faqChatMessageId) return;
    const $feedback = $chat.find(".ai-feedback");
    $feedback.find(".ai-feedback-btn").prop("disabled", true);
    try {
      const response = await fetch(CONFIG.FEEDBACK_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          conversationId: faqChatConversationId,
          messageId: faqChatMessageId,
          rating: rating,
        }),
      });
      if (!response.ok) throw new Error("Feedback failed");
      $feedback.addClass("is-submitted");
      $feedback.find(".ai-feedback-label").text(
        rating === "up"
          ? "Thanks for your feedback!"
          : "Thanks for your feedback!"
      );
    } catch (err) {
      console.error("Feedback API error:", err);
      $feedback.find(".ai-feedback-btn").prop("disabled", false);
    }
  }
  function bindAiFeedbackHandlers($chat) {
    $chat.find(".ai-feedback-btn").off("click").on("click", function () {
      const rating = $(this).data("rating");
      if (!rating || $chat.find(".ai-feedback").hasClass("is-submitted")) return;
      $chat.find(".ai-feedback-btn").removeClass("is-selected");
      $(this).addClass("is-selected");
      submitAiFeedback(rating, $chat);
    });
  }
  function buildAiFeedbackHtml() {
    return `
      <div class="ai-feedback" style="display:flex;align-items:center;gap:10px;margin-top:12px;padding-top:12px;border-top:1px solid #e5e7eb;">
        <span class="ai-feedback-label" style="font-size:13px;color:#6b7280;font-weight:500;">Was this helpful?</span>
        <div style="display:flex;gap:6px;">
          <button type="button" class="ai-feedback-btn ai-feedback-up" data-rating="up" aria-label="Thumbs up"
            style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:8px;border:1.5px solid #d1d5db;background:#ffffff;color:#6b7280;cursor:pointer;padding:0;transition:all 0.2s ease;"
            onmouseover="if(!this.classList.contains('is-selected')){this.style.borderColor='#1a2e6b';this.style.color='#1a2e6b';this.style.background='#f0f4ff';}"
            onmouseout="if(!this.classList.contains('is-selected')){this.style.borderColor='#d1d5db';this.style.color='#6b7280';this.style.background='#ffffff';}">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M7 10v12"/>
              <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/>
            </svg>
          </button>
          <button type="button" class="ai-feedback-btn ai-feedback-down" data-rating="down" aria-label="Thumbs down"
            style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:8px;border:1.5px solid #d1d5db;background:#ffffff;color:#6b7280;cursor:pointer;padding:0;transition:all 0.2s ease;"
            onmouseover="if(!this.classList.contains('is-selected')){this.style.borderColor='#1a2e6b';this.style.color='#1a2e6b';this.style.background='#f0f4ff';}"
            onmouseout="if(!this.classList.contains('is-selected')){this.style.borderColor='#d1d5db';this.style.color='#6b7280';this.style.background='#ffffff';}">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 14V2"/>
              <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"/>
            </svg>
          </button>
        </div>
      </div>`;
  }
  function showPIIWarning(piiKey) {
    let $chat = $("#chatbaseAnswer");
    if (!$chat.length) {
      $chat = $('<div id="chatbaseAnswer" class="chatbase-answer"></div>').insertAfter($searchResults);
    }
    const labels = PII_LABELS;
    $chat.html(`
      <div class="results-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/>
        </svg>
        <span>Smart search, powered by AI</span>
      </div>
      <div class="result-content pii-warning">
        <p><strong>For your security, please don't share personal information here.</strong></p>
        <p>Your message looks like it contains a ${labels[piiKey] || 'personal detail'}. This chat can't process personal or account details.</p>
        <p>For account-specific help, contact ALDI Mobile:</p>
        <ul>
          <li>Call <strong>1300 989 000</strong> (8am–9pm AET, daily)</li>
          <li>From your ALDI Mobile: dial <strong>2534</strong> (free)</li>
          <li>Or use the <a href="/pages/contact-us">contact form</a></li>
        </ul>
      </div>
    `);
    $("html, body").animate({ scrollTop: $chat.offset().top - 220 }, 300);
  }
  async function handleSearch(keyword) {
    if (searchLock) return;
    searchLock = true;
    await faqPreloadPromise;
    const term = keyword.trim().toLowerCase();
    $searchResults.empty();
    $("#chatbaseAnswer").remove();
    faqChatConversationId = null;
    faqChatMessageId = null;
    $tabs.removeClass("active");
    $faqBlocks.addClass("is-hidden-tab");
    $(".faq_tab_content_box .h3-title").hide();
    if (!term) {
      showTabByHandle($tabs.first().data("blog"));
      searchLock = false;
      return;
    }
    // ---------- PII pre-submit guard ----------
    // Use original (non-lowercased) keyword so uppercase-based patterns still match
    const piiHit = detectPII(keyword);
    if (piiHit) {
      $searchBlock.show().removeClass("is-hidden-tab").closest(".faq_tab_content_box").removeClass("is-hidden-tab");
      $searchBlock.find(".h3-title").hide();
      showPIIWarning(piiHit);
      searchLock = false;
      return;
    }
    // ------------------------------------------
    $searchBlock.show().removeClass("is-hidden-tab").closest(".faq_tab_content_box").removeClass("is-hidden-tab");
    const added = new Set();
    let match = 0;
    let firstMatchShown = false;
    const displayResult = ($el) => {
      const title = $el.find(".h4_title").text().trim().toLowerCase();
      const body = $el.find(".faq_content").text().trim().toLowerCase();
      const combinedText = title + " " + body;
      const uniqueKey = title + "|" + body;
      if (combinedText.includes(term) && !added.has(uniqueKey)) {
        const $clone = $el.clone();
        $clone.removeClass("active_faq").find(".faq_content").hide();
        if (!firstMatchShown) {
          $clone.addClass("active_faq");
          $clone.find(".faq_content").css("display", "block");
          $searchResults.append($clone);
          setTimeout(() => {
            const offset = window.innerWidth < 575 ? 220 : 180;
            $("html, body").animate({ scrollTop: $clone.offset().top - offset }, 300);
          }, 10);
          firstMatchShown = true;
        } else {
          $searchResults.append($clone);
        }
        added.add(uniqueKey);
        match++;
      }
    };
    const handles = $tabs
      .map(function () {
        return $(this).data("blog");
      })
      .get();
    for (const handle of handles) {
      const items = await (faqPageCache[handle] || []);
      items.forEach((item) => displayResult($(item)));
    }
    const cap = term.charAt(0).toUpperCase() + term.slice(1);
    $searchBlock.find(".h3-title").text(`FAQs for “${cap}”`).show();
    if (!match) {
      $searchResults.html(`<p class="no_result">There were no direct matching FAQ articles, however we&#39;ve pulled together the most relevant help below</p>`);
      setTimeout(() => {
        const $target = $(".no_result");
        if ($target.length) {
          $("html, body").animate({
            scrollTop: $target.offset().top - 180,
          }, 300);
        }
      }, 50);
    }
    $searchResults.find(".accordion_trigger").off("click").on("click", function () {
      const $item = $(this).closest(".accordion_items");
      const $content = $item.find(".faq_content");
      const isActive = $item.hasClass("active_faq");
      $searchResults.find(".accordion_items").removeClass("active_faq").find(".faq_content").slideUp();
      if (!isActive) {
        $item.addClass("active_faq");
        $content.slideDown();
      }
    });
    await performChatbaseSearch(term);
    setTimeout(() => {
      searchLock = false;
    }, 300);
  }
  async function performChatbaseSearch(query) {
    let $chat = $("#chatbaseAnswer");
    if (!$chat.length) {
      $chat = $('<div id="chatbaseAnswer" class="chatbase-answer"></div>').insertAfter($searchResults);
    }
    const chatbaseTitle = `
  <div class="results-header">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles-icon lucide-sparkles">
    <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/><path d="M20 2v4"/><path d="M22 4h-4"/><circle cx="4" cy="20" r="2"/>
    </svg>
    <span>Smart search, powered by AI</span>
  </div>
`;
    $chat.html(
      chatbaseTitle + `<div class="result-content">Looking for the most helpful answer just a moment...</div>`
    );
    const fallbackTimer = setTimeout(() => {
      $chat.find(".result-content").append('<br><em>Still working... Thanks for your patience, this may take a few more seconds.</em>');
    }, 8000);
    try {
      const response = await fetch(CONFIG.CHAT_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: query,
          userId: "faq-search",
          conversationId: faqChatConversationId,
        }),
      });
      clearTimeout(fallbackTimer);
      if (!response.ok) {
        const errBody = await response.json().catch(() => ({}));
        throw new Error(errBody.error || `HTTP ${response.status}: ${response.statusText}`);
      }
      const data = await response.json();
      if (data.conversationId) faqChatConversationId = data.conversationId;
      if (data.messageId) faqChatMessageId = data.messageId;
      const formatted = markdownToHtml(data.reply || data.text || "");
      $chat.html(
        chatbaseTitle +
          `<div class="result-content">${formatted}</div>` +
          buildAiFeedbackHtml() +
          `<div class="ai-disclaimer">
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#98500F"
        d="M9.663 4.635C10.108 3.74 10.986 3.125 12.001 3.125C13.016 3.125 13.893 3.74 14.338 4.635L20.648 16.854C20.665 16.888 20.68 16.923 20.693 16.959C21.001 17.813 20.916 18.783 20.451 19.562C19.983 20.347 19.166 20.868 18.241 20.875H5.78499C5.76799 20.875 5.75201 20.875 5.73601 20.874C5.70301 20.876 5.67001 20.876 5.63601 20.874C4.73501 20.821 3.95701 20.286 3.51701 19.51C3.07901 18.738 3.00601 17.792 3.30801 16.958C3.32101 16.922 3.33601 16.888 3.35301 16.854L9.663 4.635ZM5.73601 19.126C5.75201 19.126 5.76799 19.125 5.78499 19.125H18.23C18.482 19.122 18.762 18.979 18.948 18.666C19.131 18.36 19.177 17.959 19.063 17.599L12.875 5.617V13C12.875 13.483 12.483 13.875 12 13.875C11.517 13.875 11.125 13.483 11.125 13V5.619L4.93801 17.6C4.82601 17.951 4.86601 18.342 5.03901 18.647C5.21701 18.96 5.48801 19.111 5.73601 19.126ZM12.875 16V17C12.875 17.483 12.483 17.875 12 17.875C11.517 17.875 11.125 17.483 11.125 17V16C11.125 15.517 11.517 15.125 12 15.125C12.483 15.125 12.875 15.517 12.875 16Z" />
    </svg>
` +
          `Our AI uses FAQs to answer your questions. For important details or complex queries, it&#39;s best to contact our support team directly as our AI can&#39;t guarantee 100% accuracy. If you spot any issues in your response please let us know.</div>`
      );
      bindAiFeedbackHandlers($chat);
      $("html, body").animate({ scrollTop: $chat.offset().top - 220 }, 300);
    } catch (err) {
      clearTimeout(fallbackTimer);
      console.error("Chat API error:", err);
      $chat.html(
        `<div class="results-header">Oops! Something went wrong</div>` +
          `<div class="error-message">We couldn&#39;t get an AI answer right now. Please try again soon.</div>`
      );
    }
  }
  function markdownToHtml(md) {
    return marked.parse(md);
  }
  function initialize_faqs($faqSlider) {
    const handleFromURL = window.location.pathname.includes("/blogs/")
      ? window.location.pathname.split("/blogs/")[1].split("/")[0]
      : null;
    const $targetTab = $tabs.filter(`[data-blog='${handleFromURL}']`);
    localStorage.removeItem("faq_active_index");
    if (window.innerWidth >= 576) {
      if ($faqSlider.length && !$faqSlider.hasClass("slick-initialized")) {
        $faqSlider.slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 1000,
          dots: true,
          arrows: true,
          prevArrow:
            '<button type="button" class="slick-arrow slick-prev plan_options_prev"></button>',
          nextArrow:
            '<button type="button" class="slick-arrow slick-next plan_options_next"></button>',
          rows: 0,
          autoplay: false,
          responsive: [
            { breakpoint: 1400, settings: { slidesToShow: 3 } },
            { breakpoint: 992, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } },
          ],
        });
      }
      if ($targetTab.length) {
        const index = $tabs.index($targetTab);
        setTimeout(() => {
          if ($faqSlider.hasClass("slick-initialized")) {
            $faqSlider.slick("slickGoTo", index);
            $faqSlider.find(".slick-slide").removeClass("active").eq(index).addClass("active");
            if (!jQuery('[data-blog="' + handleFromURL + '"]').hasClass("active")) {
              jQuery('[data-blog="' + handleFromURL + '"]').addClass("active");
              showTabByHandle(handleFromURL);
            }
          }
        }, 100);
      } else {
        setTimeout(() => {
          if ($faqSlider.hasClass("slick-initialized")) {
            $faqSlider.slick("slickGoTo", 0);
            $faqSlider.find(".slick-slide").removeClass("active").eq(0).addClass("active");
            var firstHandle = $tabs.first().data("blog");
            if (!jQuery('[data-blog="' + firstHandle + '"]').hasClass("active")) {
              jQuery('[data-blog="' + firstHandle + '"]').addClass("active");
              showTabByHandle(firstHandle);
            }
          }
        }, 100);
      }
    } else {
      if ($faqSlider.hasClass("slick-initialized")) {
        $faqSlider.slick("unslick");
      }
      if ($targetTab.length) {
        $targetTab.addClass("active");
        showTabByHandle($targetTab.data("blog"));
        scrollToElement(jQuery(".main_faq_content")[0]);
      } else {
        $tabs.eq(0).addClass("active");
        showTabByHandle($tabs.eq(0).data("blog"));
      }
    }
  }
  let faqResizeTimeout;
  let currentFaqWindowWidth = window.innerWidth;
  initialize_faqs($faqSlider);
  $(window).on("resize", function () {
    clearTimeout(faqResizeTimeout);
    faqResizeTimeout = setTimeout(function () {
      const newFaqWindowWidth = window.innerWidth;
      if (
        (currentFaqWindowWidth < 576 && newFaqWindowWidth >= 576) ||
        (currentFaqWindowWidth >= 576 && newFaqWindowWidth < 576)
      ) {
        initialize_faqs($faqSlider);
      }
      currentFaqWindowWidth = newFaqWindowWidth;
      equalizeUlHeights(jQuery(".most_popular_plans_slider"));
    }, 300);
  });
  $(document).on("click", ".faq_category_slider .faq_category_box", function () {
    const $clicked = $(this);
    const handle = $clicked.data("blog");
    const index = $clicked.closest(".slick-slide").data("slick-index");
    if (handle) {
      localStorage.setItem("faq_active_index", index);
      $(".faq_category_slider .slick-slide").removeClass("active");
      $clicked.closest(".slick-slide").addClass("active");
      window.location.href = `/blogs/${handle}`;
    }
  });
  $searchForm.on("submit", function (e) {
    e.preventDefault();
    updateInputUiState();
    handleSearch($searchInput.val());
  });
  $hotSearchChips.on("click", function () {
    const term = $(this).data("hot-search");
    if (!term) return;
    $searchInput.val(term).trigger("focus");
    updateInputUiState();
    handleSearch(term);
  });
  $searchClearBtn.on("click", function () {
    $searchInput.val("").trigger("focus");
    updateInputUiState();
  });
  $searchInput.on("input", function () {
    updateInputUiState();
    if (!$(this).val().trim()) {
      location.reload();
    }
  });
  updateInputUiState();
});